import { API_BASE_URL_ENV } from "../../jsx/common/common";
import BaseService from "../BaseService";

const apiEndpoint = API_BASE_URL_ENV() + "/assets";

export default class AssetsService extends BaseService {
	constructor() {
		super(apiEndpoint);
	}
}
